import React from "react";
import { Navigate } from "react-router-dom";

import { ProtectedLayout } from "@app/layout";
import constants from "@constants/constants";

import Auth from "config/auth";

const {
  PAGE_ROUTES: { LOGIN_ROUTE, NO_ACCESS_ROUTE }
} = constants;

const ProtectedRoute = ({ roles = [], component: Component }) => {
  const isAuthenticated = Auth.isAuthenticated();
  const userRoles = Auth.getSessionDetails()?.userRoles?.map(({ RoleName }) => RoleName) || [];

  if (!isAuthenticated) {
    return <Navigate to={LOGIN_ROUTE} />;
  }

  const hasAccess = roles.some(role => userRoles.includes(role));

  if (!hasAccess) {
    return <Navigate to={NO_ACCESS_ROUTE} />;
  }

  return (
    <ProtectedLayout>
      <Component />
    </ProtectedLayout>
  );
};

export default ProtectedRoute;
